// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b9191a11","455":"98eb9065","488":"da07836a","977":"cb9f1d27"}[chunkId] + ".chunk.js";
};